export const V1_VEW = '/view/v1/list-view/find-by-code/'
export const V1_VEW_POST = '/view/v1/list-view/find-by-code'
export const V1_VEW_HASHCODE = '/view/v1/list-view/encrypt'